var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0234 9.02344C17.0234 13.442 13.442 17.0234 9.02344 17.0234C4.60484 17.0234 1.02344 13.442 1.02344 9.02344C1.02344 4.60484 4.60484 1.02344 9.02344 1.02344C13.442 1.02344 17.0234 4.60484 17.0234 9.02344Z",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 11.5677L8.73047 9.62266V5.43066",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiconTime);
export default __webpack_public_path__ + "static/media/micon-time.237e715fe801789f630084096e31edf1.svg";
export { ForwardRef as ReactComponent };